module.exports = __webpack_public_path__ + "static/img/实验室综合管理系统.7e017b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/实验室综合管理系统.png
// module id = 3I4K
// module chunks = 13